export const extractDynamicVariables = (prompt = "") => {
    const matches = [];
    const regex = /{{\s*([^{}]+?)\s*}}|{\s*([^{}]+?)\s*}/g;
    let match;

    while ((match = regex.exec(prompt)) !== null) {
        const key = (match[1] || match[2] || "")
            .trim()
            .replace(/\s+/g, "_");

        if (key && !matches.includes(key)) {
            matches.push(key);
        }
    }

    return matches;
};
